// extracted by mini-css-extract-plugin
export default {"container":"SocialLinks_container__-C1yI"};